import { appEnv } from 'build/validation'

export const getApiRoute = (domain: string, route?: string): string =>
  `${appEnv.backendUrl}${appEnv.backendUrl.endsWith('/') ? '' : '/'}api${domain}${
    route ? '/' + route : ''
  }`
